import React, { FunctionComponent } from 'react';
import { Field } from 'react-final-form';
import { RadioButtonField, RadioButtonGroup } from 'mdlkit';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const StyledRadioButtonGroup = styled(RadioButtonGroup)`
  &:focused {
    box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #000000 !important;
  }
`;

interface Props {
  isPrimary?: boolean;
  // PPW-6512 — locks the gender radios read-only when gender is carried from the coverage-check flow.
  disabled?: boolean;
  [key: string]: any;
}

export const Gender: FunctionComponent<Props> = ({
  isPrimary,
  disabled = false,
  ...rest
}: Props) => {
  const name = isPrimary ? 'primaryGender' : 'gender';
  const { formatMessage: f } = useIntl();
  return (
    <StyledRadioButtonGroup {...rest}>
      <Field
        id={`${name}-female`}
        type="radio"
        label={f({ id: 'register.gender.female' })}
        name={name}
        component={RadioButtonField}
        value="female"
        disabled={disabled}
      />
      <Field
        id={`${name}-male`}
        type="radio"
        label={f({ id: 'register.gender.male' })}
        name={name}
        component={RadioButtonField}
        value="male"
        disabled={disabled}
      />
      <Field
        id={`${name}-non-binary`}
        type="radio"
        label={f({ id: 'register.gender.nonBinary' })}
        name={name}
        component={RadioButtonField}
        value="non-binary"
        disabled={disabled}
      />
    </StyledRadioButtonGroup>
  );
};

export default Gender;
